import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  rootNoData: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#F7F8FC",
    color: "#9A9AAF",
    height: "224px",
    boxShadow: "inset 0px 4px 4px rgba(0, 0, 0, 0.03)",
    fontWeight: 400,
    fontSize: "14px",
  },
  noDataText: {
    fontFamily: "'Inter'",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "16px",
    color: "#9A9AAF",
    marginTop: "16px",
  },
  rootData: {
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: "24px 5px",
    gap: "8px",
    flexWrap: "nowrap",
  },
  rootItem: {
    borderRadius: "10px",
    maxWidth: "100%",
    display: "flex",
    position: "relative",
  },
  itemIcon: {
    borderRadius: "10px 0 0 10px",
    boxShadow: "0px 6px 16px 0px rgba(21, 12, 115, 0.06)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "9px 13px",
  },
  itemContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "9px 13px",
    boxShadow: "0px 6px 16px 0px rgba(21, 12, 115, 0.06)",
    borderRadius: "0 10px 10px 0",
  },
  itemName: {
    color: "#373534",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "120%",
    letterSpacing: "-0.12px",
    marginLeft: "6px",
  },
  itemResult: {
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "120%",
    letterSpacing: "-0.18px",
  },
  itemUpdate: {
    color: "#9A9AAF",
    fontSize: "10px",
    lineHeight: "16px",
    display: "flex",
    alignItems: "center",
    marginLeft: "8px",
    minWidth: "99px",
  },
  subScoresWrapper: {
    display: "flex", 
    borderRadius: "15px", 
    background: "linear-gradient(0deg, rgba(242, 243, 247, 0.40) 0%, rgba(242, 243, 247, 0.40) 100%), var(--Shades-Base, #FFF)",
    padding: "15px 15px 10px 15px", 
    gap: "15px", 
    flexWrap: "nowrap"
  }, 
  subScoresTitle: {
    color: theme.palette.grey.grey500, 
    fontSize: "10px", 
    fontWeight: "600", 
    letterSpacing: "-0.1px"
  }, 
  subScoresItemsWrapper : {
    display: "flex", 
    gap: "10px",
    marginTop: "10px"
  },
  subScoresItem : {
    display: "flex", 
    flexDirection: "column",
    gap: "5px",
    justifyContent: "center",
    alignItems: "center", 
  }, 
  subScoresItemIcon : {
    width: "42px",
    height: "42px", 
    flexShrink: 0, 
    borderRadius: "8px",
    display: "flex", 
    justifyContent: "center",
    alignItems: "center"
  },
  subScoresItemTitle : {
    fontSize: "12px", 
    fontWeight: "500", 
    letterSpacing: "-0.12px",
    color : theme.palette.black.dark
  },
  tooltipScoreText : {
    fontSize: "14px",
    fontWeight: "700",
    lineHeight: "130%"
  }
}));

export default useStyles;
